/**
 * Resolves a `MaybeRef` value to its underlying `HTMLElement`, or `null` if unavailable.
 * Handles both plain DOM nodes and React `RefObject` wrappers transparently.
 */
export const resolve = (r) => !r
    ? null
    : ("current" in r
        ? r.current
        : r) ?? null;
